// Privacy page entry point — auth-aware nav only
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import './landing.css';
import './privacy.css';

const firebaseConfig = {
  apiKey: "AIzaSyCO_SNK4hGIt2SUVm6yJ2UMqRTjiVxXwLo",
  authDomain: "pelaikan-app.firebaseapp.com",
  projectId: "pelaikan-app",
  storageBucket: "pelaikan-app.firebasestorage.app",
  messagingSenderId: "772587166095",
  appId: "1:772587166095:web:826c89e1d2e5355bdbd3fa",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

document.addEventListener('DOMContentLoaded', () => {
  const navSignin = document.getElementById('nav-signin');
  const navUserMenu = document.getElementById('nav-user-menu');
  const navUserEmail = document.getElementById('nav-user-email');

  onAuthStateChanged(auth, (user) => {
    if (user) {
      if (navSignin) navSignin.style.display = 'none';
      if (navUserMenu) navUserMenu.style.display = 'flex';
      if (navUserEmail) navUserEmail.textContent = user.email;
    } else {
      if (navSignin) navSignin.style.display = 'inline-flex';
      if (navUserMenu) navUserMenu.style.display = 'none';
    }
  });

  if (navSignin) {
    navSignin.addEventListener('click', () => {
      window.location.href = '/#signin';
    });
  }

  // Tab switching
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('tab-active'));
      btn.classList.add('tab-active');
      document.querySelectorAll('.tab-panel').forEach(p => p.style.display = 'none');
      document.getElementById('tab-' + tab).style.display = 'block';
    });
  });
});
